export function HelpPage() {
    return (
        <div className="jumbotron">            
            <h1 className="display-4">Help</h1>                        

            <h3 id="source-connection">Configuration of Connected App in Salesforce</h3>
            <ul>
                <li>
                    Go to <code>Setup -&gt; App Manager -&gt; New Connected App -&gt; Create a Connected App</code>
                    <div className="alert alert-warning" role="warning">You can use <code>Create an External Client App</code>, but be aware that this type of Connected App is not supported in <b>scratch</b> orgs</div>
                </li>
                <li>
                    Give your connected application name, e.g. Arcane
                </li>
                <li>Enable <code>Enable OAuth Settings</code> checkbox</li>
                <li>Put <code>https://localhost</code> into Callback URL</li>
                <li>Enable <code>Enable Client Credentials Flow</code>. This is required for successful authentication with Salesforce and establishing a connection.</li>
                <li>Add <code>Manage user data via APIs</code> scope</li>
                <li>Save the app and go to <code>Manage</code> connected app to <code>Edit policies</code></li>
                <li>Select <code>Run As</code> user in <code>Client Credentials Flow</code> section and click <code>Save</code></li>
                <li>Go to <code>View</code> Connected App (go back to <code>Setup -&gt; App Manager -&gt; [your connected app name]</code> and select <code>View</code> action)</li>
                <li>Click <code>Manage Consumer Details</code> button to obtain <code>Consumer Key</code> and <code>Consumer Secret</code></li>
            </ul>
            <br/>
            <br/>
            
            <h3 id="certificate-configuration">Certificate configuration</h3>
            <ul>
                <li>
                    Create a self-signed certificate in <code>Setup -&gt; Certificate and Key Management -&gt; Create Self-Signed Certificate</code>
                    <div className="alert alert-info" role="info">Some orgs come with a predefined self-signed certiface (e.g., created by Salesforce) which could be used instead. Another option is to use a certificate created outside of the Salesforce. 
                        For additional information reach out to <b>your company security team</b>.
                    </div>
                </li>
                <li>
                    Give your certificate a name, e.g. ArcaneCertificate
                </li>
                <li>
                    Download the certificate (in <code>.crt</code> format) and upload it to the portal (on Source configuration page)
                </li>                
            </ul>
            <br/>
            <br/>

            <h3 id="sharepoint-connector-configuration">Configuring the SharePoint Connector</h3>
            <br/>
            <h4>Configure a Microsoft Entra OAuth App</h4>
            <ol>
                <li>
                    Follow these instructions:&nbsp;
                    <a href=" https://learn.microsoft.com/en-us/entra/identity-platform/quickstart-register-app">
                        Register an application in Microsoft Entra ID
                    </a>
                </li>
                <li>
                    Follow the instructions to add the API permissions below to your OAuth app:&nbsp;
                    <a href="https://learn.microsoft.com/en-us/entra/identity-platform/howto-update-permissions?pivots=portal">
                        Update an app's requested permissions in Microsoft Entra ID
                    </a>
                    <ul>
                        <li>SharePoint &gt; Sites.FullControl.All</li>
                        <li>SharePoint &gt; User.Read.All</li>
                    </ul>
                </li>
                <li>Submit a request to your Azure admin to approve the requested API permissions, or approve them by navigating back to the API Permissions pane of your Microsoft Entra app and clicking the "Grant admin consent for " - requires the Privileged Role Administrator role.</li>
                <li>Install git:&nbsp;
                    <a href="https://git-scm.com/downloads">
                        https://git-scm.com/downloads
                    </a>
                </li>
                <li>Open the git bash app and run the following command:
                    <div className="alert alert-info" role="info">
                        <code>openssl req -nodes -newkey pkcs8:2048 -keyout azure-ad.key -out azure-ad.csr</code><br/>
                        # Note: you can replace azure-ad with whatever name you prefer for the key and csr
                    </div>
                </li>
                <li>At this point you have the option of going through a Certificate Authority (CA) to generate your x509 certificate. Alternatively, to proceed with generating a self-signed certificate, run the following command in git bash:
                    <div className="alert alert-info" role="info">
                        <code>openssl req -new -x509 -key azure-ad.key -out azure-ad.cer</code><br/>
                        # If you changed azure-ad to something else above, do it here too
                    </div>
                </li>
                <li>Follow the instructions to upload the certificate you generated (azure-ad.cer) to your Microsoft Entra app:&nbsp;
                    <a href="https://learn.microsoft.com/en-us/entra/identity-platform/how-to-add-credentials?tabs=certificate">
                        Add and manage application credentials in Microsoft Entra ID
                    </a>
                </li>
            </ol>
            <br/>
            <h4>Configure SharePoint and Gather Information</h4>
            <ol>
                <li>Navigate to the folder where your files will be uploaded and follow these instructions to create a custom column:&nbsp;
                    <a href="https://support.microsoft.com/en-us/office/create-a-column-in-a-list-or-library-2b0361ae-1bd3-41a3-8329-269e5f81cfa2">
                        Create a column in a list or library
                    </a>
                    <ul>
                        <li>Select "Text" as the column type</li>
                        <li>Enter <code>salesforceRecordId</code> as the name</li>
                        <li>Click More Options at the bottom and set the Maximum Number of Characters to 18</li>
                    </ul>
                </li>
                <li>Navigate to your folder in SharePoint and determine your URL encoded folder name. This will be the part of the url that is between "?id=" and "&viewid=". Our example value for illustration purposes is <code>%2FShared%20Documents%2FSalesforce%20Documents</code></li>
                <li>In google search "URL Decode", then paste your url encoded folder name into the Encoder Decoder dialog and click Decode. In the example above the value returned would be <code>/Shared Documents/Salesforce Documents</code></li>
                <li>Remove the leading slash (example value: <code>Shared Documents/Salesforce Documents</code>) to determine your folder name</li>
            </ol>
        </div>
        
    );
}              
            